import { useContext, useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material"
import { ToolListShuffle } from "./ToolListShuffle";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { GenerateInterval } from "./generateInterval/GenerateInterval";
import { FetchingGraphDates } from "../../global/GlobalFcn";
import { rqx } from "../../../../../core/request/API";
import { env } from "../../../../../core/Env";
import moment from "moment";

export const AccessTools = ({platform}) => {
    const { usage_state, tool_state } = useContext(ToolContext)
    const { form, graphDatasets } = usage_state
    const { __SESSION } = tool_state

    const urlParams = new URLSearchParams(window.location.search);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const __graphinit = async() => {
        if (form.data.order.value === '' && urlParams.get('tabs') === 'usage-overview') {
            form.set({...form.data,
                // department:{value: 967, stat: false, msg: ''},
                date:{...form.data.date, value:new Date()},
                order:{...form.data.order, value:'desc'},
            })
            let res_dates = await FetchingGraphDates('daily', 4, 'desc', moment(new Date()).format("MM-DD-YYYY"), '1st')
            
            graphDatasets.set((prev) => ({...prev, 
                ...res_dates,
                assigned_id:parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]),
                first_name:__SESSION.data.pinfo[0].first_name,
                last_name:__SESSION.data.pinfo[0].last_name,
                middle_name:__SESSION.data.pinfo[0].middle_name,
                role_id:__SESSION.data.uaccess[0]?.role_id || 0,
                role_name:__SESSION.data.uaccess[0]?.role_name || '',
            }))
        }
    }

    const [department, setDepartment] = useState([])
    const [allUsers, setAllUsers] = useState([])
    
    const __init = async() => {
        const company_id = __SESSION.data.uaccess[0].company_id
        const owner_id = __SESSION.data.uaccess[0].owner_id

        const getAllUsers = await rqx.get(`<<global>>/${env()}/tooluser/gettooluser`, {company_id: company_id !== null ? company_id : 0, tool_id: process.env.REACT_APP_TID_BIZ, ref: 'active' })
        if (getAllUsers) {
            setAllUsers(getAllUsers.users)
        }
       
        let res = await rqx.get(`<<biz>>/${env()}/general-maintenance/masterlist/department/infinite`, {
            lastId: 0,
            limit: 100,
            company_id: company_id !== null ? company_id : 0,
            user_id: owner_id
        })
        if (res) {
            setDepartment(res)
        }
    }

    useEffect(() => {
        __graphinit()
        if (platform === 'business') {
            __init()
        }
        // eslint-disable-next-line
    }, [])

    return (
        <Box width="100%" minHeight="200px" display="flex" flexDirection="column" gap="12px">
            <Box minHeight="48px" width="100%" display="flex" alignItems="center" justifyContent="space-between">
                <Box minHeight="48px" display="flex" alignItems="center" gap="12px">
                    <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%">Accessed Tools</Typography>
                    <Typography fontWeight={600} fontSize={16} lineHeight="120%" letterSpacing="-0.75%" color="#5DB55D">Info</Typography>
                </Box>
                <Button sx={{height:'100%', width:'166px', borderRadius:'6px', bgcolor:'#5DB55D', ':hover':{bgcolor:'#5DB55D'} }}
                    id="basic-button"
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={(e)=>handleClick(e)}
                >
                    <Typography fontWeight={600} fontSize={14} lineHeight="147%" letterSpacing="0%" color="#0C3A0C">Generate Interval</Typography>
                </Button>
            </Box>
            <ToolListShuffle/>
            <GenerateInterval platform={platform} __SESSION={__SESSION} usage_state={usage_state} anchorEl={anchorEl} setAnchorEl={setAnchorEl} open={open} department={department} allUsers={allUsers}/>
        </Box>
    )
}